import $ from 'jquery'

toolkit.$inject = ['$http', 'configuration']
export default function toolkit($http, config) {
  var endPoint = config.toolkitRoot + '/api'
  return {
    publishedGoals: function() {
      var params = { published: true }
      return $http.get(endPoint + '/goals/filter?' + $.param(params), { withCredentials: false })
    },
    filterGoals: function(params) {
      return $http.get(endPoint + '/goals/filter?' + $.param(params), { withCredentials: false })
    },
    authors: function() {
      return $http.get(endPoint + '/authorsmap', { withCredentials: false })
    }
  }
}
